var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8186 9.01553C20.8306 9.19053 20.8306 9.36553 20.8306 9.54215C20.8306 14.9236 16.7339 21.13 9.24274 21.13V21.1268C7.02984 21.13 4.8629 20.4962 3 19.301C3.32177 19.3397 3.64516 19.3591 3.96935 19.3599C5.80323 19.3615 7.58468 18.7462 9.02742 17.6131C7.28468 17.58 5.75645 16.4438 5.22258 14.7849C5.83306 14.9026 6.4621 14.8784 7.06129 14.7147C5.16129 14.3309 3.79435 12.6615 3.79435 10.7228C3.79435 10.705 3.79435 10.6881 3.79435 10.6712C4.36048 10.9865 4.99435 11.1615 5.64274 11.1809C3.85323 9.98489 3.30161 7.60424 4.38226 5.74295C6.45 8.28731 9.50081 9.83408 12.7758 9.99779C12.4476 8.58328 12.896 7.10102 13.954 6.10666C15.5944 4.56473 18.1742 4.64376 19.7161 6.28328C20.6282 6.10344 21.5024 5.76876 22.3024 5.29457C21.9984 6.23731 21.3621 7.03812 20.5121 7.54699C21.3194 7.45182 22.1081 7.2357 22.8508 6.90586C22.304 7.72521 21.6153 8.43892 20.8186 9.01553Z",
    fill: "#1DA1F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e420f50c1e77ed9c2d0f255711da8ff1.svg";
export { ForwardRef as ReactComponent };